

export enum PermissionLevel {
    None = 0,
    Admin = 1,
    Editor = 2,
    Readonly = 3
}

export namespace PermissionLevel {
    export function toString(permissionLevel: PermissionLevel): string {
        switch (permissionLevel) {
          case PermissionLevel.None:
            return 'None';
            case PermissionLevel.Admin:
                return 'Admin';
            case PermissionLevel.Editor:
                return 'Editor';
            case PermissionLevel.Readonly:
                return 'Readonly';
            default:
                return null;
        }
    }

    export function listAll() {
        return [PermissionLevel.Admin, PermissionLevel.Editor, PermissionLevel.Readonly];
    }

    export function parse(permissionLevel: string): PermissionLevel {
        return permissionLevel[permissionLevel];
    }
}

export default PermissionLevel;
